import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OauthTokenDataObject } from '../../../models/service/login';

type TokenLoginRequest = {
  grant_type: 'password';
  login_token: string;
  login_token_type?: 'magic_token';
};

export const loginWithToken = async (data: TokenLoginRequest) =>
  apiClient.post<OauthTokenDataObject, ApiClientResponse<OauthTokenDataObject>>(routes.oauth.token, data, {
    skipAuth: true,
  });
